import { createSlotRecipe } from './runtime';

const idChipConfig = {"name":"idChip","className":"id-chip","slots":["root","value","link","copy","status"],"defaultVariants":{"bare":false,"wrap":false},"variantMap":{"bare":["false","true"],"wrap":["false","true"]}}

export const idChip = /* @__PURE__ */ createSlotRecipe(idChipConfig)